import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import { safeCustomElement } from '@/utilities/custom-element'
export interface KeyTakeawayItem {
  imageSrc: string
  imageAlt: string
  copy: string
  href?: string
}

@safeCustomElement('mdc-key-takeaways-section')
export class MdcKeyTakeawaysSection extends LitElement {
  @property({ type: Array }) items: KeyTakeawayItem[] = []

  static styles = css`
    :host {
      display: block;
    }

    .mdc-key-takeaways-section {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-150, 1.5rem);
    }

    .mdc-key-takeaways-section__title {
      font-family: var(--typography-font-family-sans);
      font-size: var(--typography-font-size-112-and-half);
      font-weight: 600;
      line-height: 1.3;
      letter-spacing: -0.00563rem;
      color: var(--color-functional-gray-black);
      margin: 0 0 var(--spacing-050, 0.5rem);
    }

    .mdc-key-takeaways-section__list {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-150, 1.5rem);
    }

    .mdc-key-takeaway-item {
      display: flex;
      gap: var(--spacing-100, 1rem);
      align-items: flex-start;
      text-decoration: none;
      color: inherit;
    }

    .mdc-key-takeaway-item__image {
      box-sizing: border-box;
      flex-shrink: 0;
      width: 5rem;
      height: 5rem;
      object-fit: cover;
      border-radius: var(--radius-md, 0.5rem);
      border: 1px solid var(--color-functional-gray-200);
    }

    .mdc-key-takeaway-item__copy {
      font-family: var(--typography-font-family-sans);
      font-size: var(--typography-font-size-087-and-half);
      font-weight: 450;
      line-height: 1.3;
      color: var(--color-functional-gray-black);
      margin: 0;
    }

    .mdc-key-takeaway-item__copy strong {
      font-weight: 600;
    }
  `

  render() {
    if (!this.items?.length) return html``

    return html`
      <div class="mdc-key-takeaways-section">
        <h2 class="mdc-key-takeaways-section__title">Key Takeaways</h2>
        <div class="mdc-key-takeaways-section__list">
          ${this.items.map((item) =>
            item.href
              ? html`
                    <a class="mdc-key-takeaway-item" href=${item.href}>
                      <img
                        class="mdc-key-takeaway-item__image"
                        src=${item.imageSrc}
                        alt=${item.imageAlt}
                        loading="lazy"
                      />
                      <p class="mdc-key-takeaway-item__copy">${unsafeHTML(item.copy)}</p>
                    </a>
                  `
              : html`
                    <div class="mdc-key-takeaway-item">
                      <img
                        class="mdc-key-takeaway-item__image"
                        src=${item.imageSrc}
                        alt=${item.imageAlt}
                        loading="lazy"
                      />
                      <p class="mdc-key-takeaway-item__copy">${unsafeHTML(item.copy)}</p>
                    </div>
                  `
          )}
        </div>
      </div>
    `
  }
}
